export default {
  message: {
    Tour: {
      continue: "繼續",
      back: "返回",
      finish: "完成"
    },
    Login: {
      title: "家長登入",
      sign_in: "登入",
      login_fail:
        "驗證失敗。請重試或聯絡學校尋求協助。",
      forgot_password: "忘記密碼",
      create_account: "建立帳戶",
      password: "密碼",
      confirm_password: "確認密碼",
      password_reminder: "密碼提醒",
      enter_email: "請輸入您的電子郵件地址",
      validation_error: "驗證錯誤訊息",
      password_reminder_error_no_user_register:
        "找不到您輸入的用戶名。請重試或建立新帳戶。",
      password_reminder_error_no_user: "找不到您輸入的用戶名。",
      password_reminder_sent: "已向 {email} 發送包含進一步說明的電子郵件。",
      password_reminder_sent_message:
        "電子郵件可能需要幾分鐘才能到達。如未在收件匣中看到，請檢查垃圾郵件資料夾。",
      password_trouble_email: "如仍有問題，請聯絡 {email}。",
      password_trouble_school:
        "如仍有問題，請聯絡學校尋求協助。",
      return_to_sign_in: "返回登入",
      create_my_account: "建立我的帳戶",
      or_sign_in_with: "或使用以下方式登入",
      password_reset: "請為您的帳戶選擇新密碼。",
      password_reset_warning:
        "如果您未請求更改密碼，請立即聯絡學校管理員。",
      password_update: "選擇新密碼",
      password_update_confirm: "確認新密碼",
      password_update_success: "您的新密碼已儲存。"
    },
    AccountSettings: {
      title: "帳戶設定",
      first_name: "名字",
      last_name: "姓氏",
      email: "電子郵件",
      username: "用戶名",
      password: "密碼",
      students: "學生",
      teachers: "教師",
      external_id: "外部ID",
      phone: "電話號碼",
      edit: "編輯",
      remove: "刪除",
      add: "新增",
      remove_message: "確定要刪除此學生姓名嗎？",
      yes: "是",
      no: "否",
      add_student: "新增學生",
      close: "關閉",
      save: "儲存變更",
      cancel: "取消",
      student_alert_message: "您必須至少輸入一名學生。",
      logout: "登出"
    },
    Navbar: {
      my_meetings: "我的會議",
      language: "粵語",
      help: "幫助",
      account_settings: "帳戶設定",
      logout: "登出"
    },
    SubNavbar: {
      meeting: "會議",
      event: "活動",
      print: "列印",
      email: "電子郵件",
      export: "匯出"
    },
    ConferenceCard: {
      add_edit_meetings: "新增/編輯會議",
      opening: "開放",
      closed: "已關閉"
    },
    Agenda: {
      full_agenda: "完整議程",
      empty_state_title: "我哋搵唔到你嘅任何會議。",
      empty_state_message: "如有疑問，請聯絡學校代表。",
      confirmation_modal_title: "議程已確認",
      confirmation_modal_message:
        "您嘅議程已成功確認，已向您發送電子郵件。",
      complete_button: "完成！"
    },
    AgendaCard: {
      room: "房間不可用",
      room_with_value: "房間：{room}",
      virtual_meeting: "虛擬會議",
      all_conferences: "所有會議",
      conference: "會議",
      student: "學生",
      meeting_with: "會議對象",
      date_time: "日期/時間",
      meeting_type: "會議類型",
      location: "地點",
      comment: "評論",
      action: "操作",
      delete: "刪除",
      add_comment: "新增評論",
      join: "加入會議",
      choose_meeting_type: "選擇會議類型",
      in_person: "面對面",
      phone: "電話",
      callback: "回電",
      virtual: "虛擬",
      unavailable: "不可用",
      tooltip_translator:
        "翻譯服務唔保證提供，但學校會盡力確保可用。",
      translator_requested: "已請求翻譯",
      clear_translator: "清除翻譯請求",
      need_translator: "需要翻譯？",
      choose_language: "選擇語言"
    },
    ScheduleMatrix: {
      no_teachers_title: "未選擇教師或團隊。",
      no_teachers_message: "請選擇教師以查看其會議時間。",
      choose_teachers_button: "查看可用嘅教師或團隊",
      choose_student: "為邊位學生？",
      cancel: "取消"
    },
    Matrix: {
      teachers: "教師",
      agenda: "審核並繼續"
    },
    DrawerTeachers: {
      teachers: "教師",
      name: "姓名",
      description: "描述",
      student: "學生",
      teacher_team: "教師/團隊",
      show_more: "顯示更多教師",
      show_all: "顯示學校所有教師",
      selected: "已選 ({count})",
      closeDrawer: "繼續安排",
      search: "搜尋教師或團隊",
      not_available: "該教師喺 {date} 冇可用會議時間。"
    },
    DrawerAgenda: {
      no_meetings_title: "您冇安排嘅會議。",
      no_meetings_message: "選擇教師同時段後，會議會顯示喺呢度。",
      new_meeting_label: "新建",
      cancel_button: "取消",
      student_label: "學生",
      meeting_type_location: "會議類型/地點",
      comment_label: "評論",
      save_comment_button: "儲存評論",
      confirm_label: "請確認：",
      confirm_cancel_button: "係，取消我同 ",
      do_not_cancel_button: "唔取消",
      confirm_agenda_button: "確認此議程",
      confirm_agenda_message_line1: "您隨時可以返嚟修改。",
      confirm_agenda_message_line2: "您目前嘅議程會通過電子郵件發送俾您。"
    },
    EmailConsent: {
      message:
        "為咗保護您嘅隱私同安全，我哋需要您同意接收系統發送到您電子郵件嘅通訊。",
      consent: "同意"
    }
  }
};
